import { SignupFormContainer } from 'modules/auth/components/SignupForm/SignupFormContainer'
import { SignupFormProvider } from 'modules/auth/components/SignupForm/SignupFormProvider'
import { SignupStepper } from 'modules/auth/components/SignupStepper/SignupStepper'
import { useSignupStoreActions } from 'modules/auth/store/useSignupStore'
import { EnumSignupType } from 'modules/auth/types/signup'
import { FeedbackAlert } from 'modules/common/components/FeedbackAlert/FeedbackAlert'
import { useUserLocale } from 'modules/common/hooks/useUserLocale'
import { startSignupSessionReplay } from 'modules/common/lib/amplitude'
import { EnumUserLocale } from 'modules/common/types/locale'
import { useEffect } from 'react'

interface SignupContainerProps {
  signupType: EnumSignupType
}

export const SignupContainer = ({ signupType }: SignupContainerProps) => {
  const { setSignupType } = useSignupStoreActions()

  useEffect(() => {
    setSignupType(signupType)
  }, [setSignupType, signupType])

  const userLocale = useUserLocale()

  useEffect(() => {
    if (userLocale === EnumUserLocale.IT) {
      startSignupSessionReplay()
    }
  }, [userLocale])

  return (
    <SignupFormProvider>
      <FeedbackAlert />
      <div className="flex flex-1 flex-col bg-primary md:flex-row md:bg-white">
        <SignupStepper />
        <SignupFormContainer />
      </div>
    </SignupFormProvider>
  )
}
